// import AceEditor from 'react-ace'
import { Ace } from 'ace-builds'
import { NoRollbarErrorBoundary } from 'client/components/no-rollbar-error-boundary'
import { Tracking } from 'common/types/Page'
import React, { useEffect, useState } from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

export interface AdvancedSettingsTabProps {
  advancedFields: Tracking
  updateAdvancedSettings: (
    field: keyof Tracking,
  ) => (val: Tracking[keyof Tracking]) => void
  annotations: Ace.Annotation[]
  handleValidate: (incoming: Ace.Annotation[]) => void
  hasHtmlError: boolean
}

export const AdvancedSettingsTab = ({
  advancedFields,
  updateAdvancedSettings,
  annotations,
  handleValidate,
  hasHtmlError,
}: AdvancedSettingsTabProps) => {
  const { t } = useTypedTranslation()
  const [AceEditor, setAceEditor] = useState<React.ComponentType<any> | null>(
    null,
  )
  useEffect(() => {
    const loadCodeEditor = async () => {
      const { default: aceEditor } = await import(
        /* webpackChunkName: "code-editor" */ 'react-ace'
      )
      await import('ace-builds/src-noconflict/ext-language_tools')
      await import('ace-builds/src-noconflict/mode-html')
      await import('ace-builds/src-noconflict/theme-textmate')
      await import('ace-builds/webpack-resolver')

      setAceEditor(() => aceEditor)
    }

    loadCodeEditor()
  }, [])
  return (
    <div className="flex max-h-[618px] flex-col gap-4 overflow-y-auto">
      <span className="text-heading-4">
        {t('website_settings.sidebar.page_settings.advanced.tracking_code')}
      </span>
      <p className="text-M text-textTertiary">
        {t(
          'website_settings.sidebar.page_settings.advanced.tracking_code_info',
        )}
      </p>
      <NoRollbarErrorBoundary>
        <div
          className={
            'max-h-[calc(100vh-200px)] min-h-[466px] overflow-y-auto text-center transition-[min-height] duration-300 ease-in'
          }
        >
          {AceEditor && (
            <AceEditor
              width="700"
              mode="html"
              theme="textmate"
              fontSize={14}
              showPrintMargin={true}
              onValidate={handleValidate}
              annotations={annotations}
              showGutter={true}
              value={advancedFields?.headerCode || ''}
              highlightActiveLine={true}
              onChange={updateAdvancedSettings('headerCode')}
              name="code-editor"
              setOptions={{
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true,
                enableSnippets: false,
                showLineNumbers: true,
                tabSize: 2,
              }}
            />
          )}
        </div>
        {((advancedFields?.headerCode && annotations.length !== 0) ||
          hasHtmlError) && (
          <span className="text-red-600">
            {t('components.core.code_editor.code_is_not_valid')}
          </span>
        )}
      </NoRollbarErrorBoundary>
    </div>
  )
}
